import { render, staticRenderFns } from "./legendBox9.vue?vue&type=template&id=1fc90ca3&scoped=true&"
import script from "./legendBox9.vue?vue&type=script&lang=js&"
export * from "./legendBox9.vue?vue&type=script&lang=js&"
import style0 from "./legendBox9.vue?vue&type=style&index=0&id=1fc90ca3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc90ca3",
  null
  
)

export default component.exports